import { useEffect, useState } from "react";
import { CardBody, Table, Button, Input, Col } from "reactstrap";
import { Next } from "../../../../Constant";
import { Controller } from "react-hook-form";
import Typeahead from "../../../../CommonElements/TypeAhead";
import { viewAttribute, viewAttributeRole, viewVariant, viewVariantRole } from "../../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken } from "../../../../Utils/restUtils";

const ProOptionForm = ({ control, setNextTab, setValue, fields, append, remove, itemAttributes }) => {
  const [attributeOption, setAttributeOption] = useState([]);
  const [attributeValueOptions, setAttributeValueOptions] = useState({});
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    attributeData();
  }, []);

  useEffect(() => {
    if (attributeOption.length && itemAttributes?.length) {
      const initializeForm = async () => {
        const rows = [];

        for (let i = 0; i < itemAttributes.length; i++) {
          const attr = itemAttributes[i];

          // find attribute label
          const attribute = attributeOption.find((a) => a.value === attr.attribute_id);
          // fetch value options for this attribute
          const variantRes = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewVariant + `?attribute_id=${attr.attribute_id}` : viewVariantRole + `?attribute_id=${attr.attribute_id}`);
          const variants = variantRes?.data?.map((v) => ({ value: v.id, label: v.value })) || [];
          setAttributeValueOptions((prev) => ({ ...prev, [i]: variants }));

          // find value label
          const attributeValue = variants.find((v) => v.value === attr.option_id);

          rows.push({
            attribute: attribute || null,
            attributeValue: attributeValue || null,
            stock: attr.stock,
            price: attr.price,
            images: attr.image_url,
            image: attr.image,
          });
        }
        setValue('rows', rows);
      };
      initializeForm();
    }
  }, [attributeOption, itemAttributes]);

  const attributeData = async () => {
    const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute : viewAttributeRole);
    if (payment.status === true) {
      const set_payment = payment.data.map((items) => ({ value: items.id, label: items.title }))
      setAttributeOption(set_payment)
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const attributeValueData = async (id, index) => {
    const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewVariant + `?attribute_id=${id}` : viewVariantRole + `?attribute_id=${id}`);
    if (payment.status === true) {
      const set_payment = payment.data.map((items) => ({ value: items.id, label: items.value }))
      setAttributeValueOptions((prev) => ({
        ...prev,
        [index]: set_payment,
      }));
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const handleAddRow = () => {
    append({ attribute: null, attributeValue: null, stock: '', price: '', images: '' });
  };

  const handleRemoveRow = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  return (
    <CardBody>
      <Table bordered responsive className="mt-3">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
            <th>Stock</th>
            <th>Additional Price</th>
            <th>Images</th>
            <th style={{ width: "100px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((row, index) => (
            <tr key={row.id}>
              <td className="col-sm-12 col-md-2">
                <>
                  <Controller
                    name={`rows.${index}.attribute`}
                    control={control}
                    render={({ field }) => (
                      <Typeahead
                        options={attributeOption}
                        onChange={(selected) => {
                          field.onChange(selected);
                          if (selected?.value) {
                            attributeValueData(selected.value, index);
                          }
                          setValue(`rows.${index}.attributValue`, null);
                        }}
                        value={field.value}
                      />
                    )}
                  />
                </>
              </td>
              <td className="col-sm-12 col-md-2">
                <>
                  <Controller
                    name={`rows.${index}.attributeValue`}
                    control={control}
                    render={({ field }) => (
                      <Typeahead
                        options={attributeValueOptions[index] || []}
                        onChange={(value) => {
                          field.onChange(value);
                        }}
                        value={field.value}
                      />
                    )}
                  />
                </>
              </td>
              <td className="col-sm-12 col-md-2">
                <>
                  <Controller
                    name={`rows.${index}.stock`}
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="number"
                        placeholder="Stock"
                        {...field}
                      />
                    )}
                  />
                </>
              </td>
              <td className="col-sm-12 col-md-2">
                <>
                  <Controller
                    name={`rows.${index}.price`}
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="number"
                        placeholder="Additional Price"
                        {...field}
                      />
                    )}
                  />
                </>
              </td>
              <td className="col-sm-12 col-md-3">
                <Controller
                  name={`rows.${index}.images`}
                  control={control}
                  render={({ field }) => (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Col md="8">
                        <Input
                          type="file"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            field.onChange(file); // File object
                          }}
                        />
                      </Col>
                      <Col md="4">
                        <span className="imagestyle">
                          {field.value ? (
                            typeof field.value === 'string' ? (
                              <img src={field.value} alt="image" width="40px" height="40px" />
                            ) : (
                              <img src={URL.createObjectURL(field.value)} alt="image" width="40px" height="40px" />
                            )
                          ) : (
                            <span>No image</span>
                          )}
                        </span>
                      </Col>
                    </div>
                  )}
                />
              </td>
              <td className="text-center">
                {fields.length > 1 && (
                  <Button color="danger" size="sm" onClick={() => handleRemoveRow(index)}>
                    <i className="fa fa-trash-o"></i>
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-between mt-2">
        <Button color="primary" onClick={handleAddRow}>
          + Add
        </Button>
        <Button className="tab-button" onClick={() => setNextTab("3")}>{Next}</Button>
      </div>
    </CardBody>
  );
};

export default ProOptionForm;
